import { useRecoilValue } from "recoil";
import useMixpanelMKT from "../../hooks/useMixpanelMKT";
import { userSimpleAtom } from "../../recoil/userSimpleAtom";
import LoginButtonTemplatePromotion from "./LoginButtonTemplatePromotion";
import useKakaoLoginV6 from "../../hooks/useKakaoLoginV6";

export default function KakaoLoginButtonV6({
  render,
  onNotCoach,
}: {
  render?: (props: {
    onClick: (e?: any) => void;
    disabled?: boolean;
  }) => JSX.Element;
  onNotCoach?: () => void;
}) {
  const handleLogin = useKakaoLoginV6();
  const user = useRecoilValue(userSimpleAtom);

  const trackLoginButtonClick = useMixpanelMKT({
    eventName: "로그인 버튼 클릭",
    params: { method: "kakao" },
    version: "v6",
  });

  return (
    <LoginButtonTemplatePromotion
      loginType="kakao"
      action={() => {
        trackLoginButtonClick();
        handleLogin();
      }}
      isLoggedIn={!!user?.accessToken}
      widthPx={320}
    />
  );
}
